/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import { SnackbarManager } from '@internal-libraries/kheops-ui-lib'
import { Component, InjectReactive, Vue } from 'vue-property-decorator'
import { ClvrHttpClientError } from '../Type'
import { useSnackStore } from '../Store/snackStore'

@Component({
    inheritAttrs: false,
})
export default class ClvrComponent extends Vue {
    @InjectReactive() protected snackbarManager!: SnackbarManager
    protected snackStore = useSnackStore()

    protected addErrorSnack(message = 'clevehr:common-error_occured', onInstance = false): void {
        this.snackStore.addErrorSnack(message, onInstance)
    }

    protected addWarningSnack(message = '', onInstance = false): void {
        this.snackStore.addWarningSnack(message, onInstance)
    }

    protected addSuccessSnack(message = '', onInstance = false): void {
        this.snackStore.addSuccessSnack(message, onInstance)
    }

    protected manageApiError(error: ClvrHttpClientError): void {
        this.snackStore.manageApiError(error)
    }
}
